import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const BandageIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 2.20101C9.60135 0.599663 12.1976 0.599663 13.799 2.20101C15.4003 3.80236 15.4003 6.39865 13.799 8L8 13.799C6.39865 15.4003 3.80236 15.4003 2.20101 13.799C0.599663 12.1976 0.599663 9.60135 2.20101 8L8 2.20101ZM9.44975 5.72183C9.1066 6.06497 8.55025 6.06497 8.20711 5.72183C7.86396 5.37868 7.86396 4.82233 8.20711 4.47918C8.55025 4.13604 9.1066 4.13604 9.44975 4.47918C9.79289 4.82233 9.79289 5.37868 9.44975 5.72183ZM10.2782 7.79289C10.6213 8.13604 11.1777 8.13604 11.5208 7.79289C11.864 7.44975 11.864 6.8934 11.5208 6.55025C11.1777 6.20711 10.6213 6.20711 10.2782 6.55025C9.93503 6.8934 9.93503 7.44975 10.2782 7.79289ZM6.13604 9.03553C5.79289 9.37868 5.23654 9.37868 4.8934 9.03553C4.55025 8.69239 4.55025 8.13604 4.8934 7.79289C5.23654 7.44975 5.79289 7.44975 6.13604 7.79289C6.47919 8.13604 6.47918 8.69239 6.13604 9.03553ZM6.96447 11.1066C7.30761 11.4497 7.86396 11.4497 8.20711 11.1066C8.55025 10.7635 8.55025 10.2071 8.20711 9.86396C7.86396 9.52082 7.30761 9.52082 6.96447 9.86396C6.62132 10.2071 6.62132 10.7635 6.96447 11.1066Z"
		></path>
	</svg>
))
